<template>
  <v-container
    id="chamadaForm"
    fluid
    tag="section"
  >
    <base-material-card       
      color="primary"
      icon="mdi-clipboard-edit-outline"
      :title="$t('chamadaForm')">
      <v-form>
        <v-container class="pl-6">
          <v-row >
            <v-col
              cols="5"
              md="3"
            >
              <v-combobox
                  v-model="form.animal"
                  :items="animalList"
                  label="Animal:"
                  class="purple-input"
                  item-text="titulo"
                  clearable
                  return-object
                ></v-combobox>
            </v-col>
            <v-col
              cols="5"
              md="3"
            >
            <v-combobox
                v-model="form.pessoa"
                :items="pessoaList"
                label="Pessoa:"
                class="purple-input"
                item-text="nome"
                clearable
                return-object
              ></v-combobox>
            </v-col>
            <v-col
              cols="5"
              md="3"
            >
            <v-combobox
                v-model="form.especie"
                :items="especieList"
                label="Especie:"
                class="purple-input"
                item-text="nome"
                clearable
                return-object
              ></v-combobox>
            </v-col> 
          </v-row>
        </v-container>

        <v-btn
        class="mr-4"
        color="default"
        @click="doCarregaForm">
        Busca
        </v-btn> 
            
        <v-container class="py-0">
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Data
                  </th>
                  <th class="text-left">
                    Animal
                  </th>
                  <th class="text-left">
                    Local
                  </th>                           
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in listaDados"
                  :key="item.id"
                >
                  <td>{{ doFormataDataHora(item.dataAlteracao) }}</td>
                  <td>{{ doTitulo(item.animalDto) }}</td>
                  <td>-</td>                  
                </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-container>
      </v-form>
    </base-material-card>
  </v-container>
</template>

<script>


  import { mask } from 'vue-the-mask'
  import service from '../../../services/chamadaservice'
  import utilService from '../../../services/utils'
  import serviceespecie from '../../../services/especieservice'
  import serviceanimal from '../../../services/animalservice'  
  import servicepessoa from '../../../services/pessoaservice'
  export default {
    name: 'chamadaForm',
    directives: {
      mask,
    },
    data: () => ({
      listaDados: [{
        id: -1,
        nome: '',
        
      }],
      itemSelecionado: {

      },
      animalList: [],
      pessoaList: [],
      especieList: [],
      form: {},
      nomeErro: false,
      erros: [],
      dialog: false,
    }),
    mounted () {
      this.doCarregaForm()
      this.doBuscaEntidades()
    },
    methods: {
      doCarregaForm () {
        this.listaDados = []
        service.listar().then(resposta => {
          this.listaDados = resposta.data.list
        }).catch(e => {
          if (e.message === 'Network Error') {
            console.log('Network Error: ' + e.response)
          } else {
            console.log('Erro listar(): ')
            console.log( e)                      
          }
        })
      },
      doFormataDataHora(aData){
        return utilService.methods.formatDataHora(aData)
      },
      doValidate () {
        this.erros = []
     
        if (this.erros.length === 0) {
          return true
        }   
      },
      doEditaCadastro (item) {                
        this.itemSelecionado = item
        this.dialog = true
      },
      doNovoCadastro () {
        this.dialog = true
      },
      updateDialog (dialog) {
        this.dialog = dialog
        this.doCarregaForm()
      },      
      doTitulo(data){
        if(!data)
          return ""
        return data.titulo
      },
      doFormataData(data){
        if(!data)
          return ""
        return gettanggal(data)
      },
      doBuscaEntidades () {
        serviceanimal.listarativo().then(resp => {
          this.animalList = resp.data.list
        }).catch(e => {
          console.log(e)
        })        
        serviceespecie.listar().then(resp => {
          this.especieList = resp.data.list
        }).catch(e => {
          console.log(e)
        })
        servicepessoa.listar().then(resp => {
          this.pessoaList = resp.data.list
        }).catch(e => {
          console.log(e)          
        })         
     
      },   
    },
  }
</script>
